/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.162.0-v202610301836-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * The headers for the returned rows. The order of the headers will match the order of the datums in the rows
 */
export interface ColumnHeaderOutputV1 {
    /**
     * The ID of the column definition (for TableDefinition and StoredTable)
     */
    "id"?: string;
    /**
     * The name of the column
     */
    "name": string;
    /**
     * The type of this column
     */
    "type": TypeEnum;
    /**
     * Display unit of measure for values in this column. Null means unknown, mixed, or not applicable; empty string means unitless/dimensionless; `string` is the textual pseudo-UOM used for textual values in current Workbench table rendering.
     */
    "unitOfMeasure"?: string;
}

export const TypeEnum = {
    UUID: 'UUID',
    TEXT: 'TEXT',
    NUMERIC: 'NUMERIC',
    TIMESTAMPTZ: 'TIMESTAMPTZ',
    BOOLEAN: 'BOOLEAN'
} as const;

export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
